import api from "@basic/api";
import auth from "@basic/auth";
import store from "./store";

export default new auth(store, api.http(process.env.VUE_APP_VISITOR), "v1/auth/guest", "v1/auth/login", "v1/auth/refresh")
